import { useEffect, useState } from 'react';
import { Clock } from './Clock';
import { StatusBadge } from './StatusBadge';
import { serverStatus } from '../services/StatusService';
import logo from '../images/logo-ice2.png';
import './Header.css';

function Header() {
    const [status, setStatus] = useState(true);

    useEffect(() => {
        statusCheck();
        const id = setInterval(statusCheck, 30000);
        return () => clearInterval(id);
    }, []);

    async function statusCheck() {
        const s = await serverStatus();
        setStatus(s);
    }

    return (
        <div className="site-header">
            <img
                className="site-header-logo"
                src={logo}
                alt="Paragon Conquer"
            />
            <div className="site-header-stats">
                <div className="site-stat">
                    <span className="site-stat-label">Server</span>
                    <StatusBadge status={status ? 'online' : 'offline'} />
                </div>
                <span className="site-stat-sep" aria-hidden="true" />
                <div className="site-stat">
                    <span className="site-stat-label">Server Time</span>
                    <Clock className="site-stat-value" />
                </div>
            </div>
        </div>
    );
}

export { Header };
